export const GAMES = [
  {
    id: "wordle",
    title: "Wordle",
    description: "Test your word-guessing skills",
    href: "/games/wordle",
    color: "indigo",
  },
  {
    id: "connections",
    title: "Connections",
    description: "Find groups of four",
    href: "/games/connections",
    color: "purple",
  },
  {
    id: "personality-quiz",
    title: "AI Personality Test",
    description: "Discover your AI personality type and get tool recommendations",
    href: "/games/personality-quiz",
    color: "indigo",
  },
  {
    id: "crossword",
    title: "Mini Crossword",
    description: "Quick 5x5 crossword puzzle",
    href: "/games/crossword",
    color: "green",
  },
  {
    id: "pips",
    title: "Pips",
    description: "Arrange dominoes to solve logic puzzles",
    href: "/games/pips",
    color: "purple",
  },
  // Future games can be added here
  // {
  //   id: "trivia",
  //   title: "Daily Trivia",
  //   description: "Test your knowledge",
  //   href: "/games/trivia",
  //   color: "orange",
  // },
];
